  <!-- Progress Notes Tabs -->
  <div class="progress-notes-tabs" [ngClass]="{'tabs-blurred': isEditingExistingNote || showProgressReviewForm}">
    <div class="tab-container">
      <div class="progress-tab" [ngClass]="{'active-progress-tab': activeProgressTab === 'priority'}" (click)="selectProgressTab('priority')">
        Priority List
      </div>
      <div class="progress-tab" [ngClass]="{'active-progress-tab': activeProgressTab === 'archived'}" (click)="selectProgressTab('archived')">
        Archived List
      </div>
      <div class="progress-tab" [ngClass]="{'active-progress-tab': activeProgressTab === 'completed'}" (click)="selectProgressTab('completed')">
        Completed Progress Notes
      </div>
      <div class="progress-tab" [ngClass]="{'active-progress-tab': activeProgressTab === 'oldProgressNotes'}" (click)="selectProgressTab('oldProgressNotes')">
        Old Progress Notes
      </div>
    </div>
  </div>

<!-- Add New Notes Form -->
<div *ngIf="showAddNotesForm" class="add-notes-form-container" [ngClass]="{'form-transparent': showValidationModal}">
  <!-- Header -->
  <div class="form-header">
    <h2>{{ isEditingExistingNote ? 'Edit Progress Notes' : 'Create New Progress Notes' }}</h2>
    <button class="move-to-review-btn" (click)="moveToReview()" [disabled]="hasAnyValidationErrors()">Move to Review</button>
  </div>

  <!-- Section 1: Current Health Issues -->
  <div class="section-header-outside">
    <span class="section-number">01</span>
    <h3>Current Health Issues</h3>
  </div>
  
  <div class="form-section">
    <div class="form-content">
      <!-- Complaints -->
      <div class="form-field">
        <label>Complaints</label>
        <input 
          type="text" 
          [(ngModel)]="progressNotesForm.complaints"
          placeholder="Type Here"
          class="form-input">
      </div>

      <!-- Medical Conditions and Identified On Row -->
      <div class="form-row">
        <div class="form-field">
          <label>Medical Conditions</label>
          <select 
            [(ngModel)]="progressNotesForm.medicalConditions"
            class="form-select">
            <option value="" disabled selected>Select Here</option>
            <option *ngFor="let condition of medicalConditionsOptions" [value]="condition">
              {{condition}}
            </option>
          </select>
          <!-- Show text input when "Other" is selected -->
          <input 
            *ngIf="progressNotesForm.medicalConditions === 'Other'"
            type="text" 
            [(ngModel)]="customMedicalCondition"
            placeholder="Enter custom medical condition "
            class="form-input"
            style="margin-top: 8px;">
        </div>
        
        <div class="form-field">
          <label>Identified On</label>
          <input 
            type="date" 
            [(ngModel)]="progressNotesForm.identifiedOn"
            (change)="validateIdentifiedOnDate()"
            [max]="maxDate"
            class="form-date"
            [class.error-field]="identifiedOnError">
          <span *ngIf="identifiedOnError" class="error-message">{{ identifiedOnError }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 2: Goals Overview & Task Management -->
  <div class="section-header-outside" *ngIf="progressNotesForm.goals.length > 0">
    <span class="section-number">02</span>
    <h3>Goals Overview & Task Management</h3>
  </div>
  
  <div class="form-section" *ngFor="let goal of progressNotesForm.goals; let goalIndex = index">

    
    <div class="form-content">
      <!-- Goal to be achieved and Goal Priority Level Row -->
      <div class="form-row">
        <div class="form-field">
          <label>Goal to be achieved:</label>
          <input 
            type="text" 
            [(ngModel)]="goal.goalToBeAchieved"
            placeholder="Type Here"
            class="form-input">
        </div>

        <div class="form-field">
          <label>Goal Priority Level</label>
          <div class="priority-buttons">
            <button 
              class="priority-btn high-priority"
              [ngClass]="{'selected': goal.goalPriorityLevel === 'High'}"
              (click)="setGoalPriority(goalIndex, 'High')">
              ✓ High Priority
            </button>
            <button 
              class="priority-btn medium-priority"
              [ngClass]="{'selected': goal.goalPriorityLevel === 'Medium'}"
              (click)="setGoalPriority(goalIndex, 'Medium')">
              ✓ Medium Priority
            </button>
            <button 
              class="priority-btn low-priority"
              [ngClass]="{'selected': goal.goalPriorityLevel === 'Low'}"
              (click)="setGoalPriority(goalIndex, 'Low')">
              ✓ Low Priority
            </button>
          </div>
        </div>
      </div>

      <!-- Goal Category, Goal Start Date & Goal Target Date Row -->
      <div class="form-row">
        <div class="form-field">
          <label>Goal Category</label>
          <select 
            [(ngModel)]="goal.goalCategory"
            class="form-select">
            <option value="" disabled selected>Select here</option>
            <option *ngFor="let category of goalCategoryOptions" [value]="category">
              {{category}}
            </option>
          </select>
          <!-- Show text input when "Other" is selected -->
          <input 
            *ngIf="goal.goalCategory === 'Other'"
            type="text" 
            [(ngModel)]="customGoalCategories[goalIndex]"
            placeholder="Enter custom goal category"
            class="form-input"
            style="margin-top: 8px;">
        </div>
        
        <div class="form-field">
          <label>Goal Start Date</label>
          <input 
            type="date" 
            [(ngModel)]="goal.goalStartDate"
            (change)="validateGoalTargetDate(goalIndex)"
            class="form-date">
        </div>
        
        <div class="form-field">
          <label>Goal Target Date</label>
          <input 
            type="date" 
            [(ngModel)]="goal.goalTargetDate"
            (change)="validateGoalTargetDate(goalIndex)"
            [min]="goal.goalStartDate"
            class="form-date"
            [class.error-field]="goalDateErrors[goalIndex]">
          <span *ngIf="goalDateErrors[goalIndex]" class="error-message">{{ goalDateErrors[goalIndex] }}</span>
        </div>
      </div>

      <!-- Add Tasks Section -->
      <div class="tasks-section">
        <div class="tasks-header">
          <label>Add Tasks: {{goal.tasks.length}}</label>
        </div>
        
        <div class="task-item" *ngFor="let task of goal.tasks; let taskIndex = index">
          <div class="task-fields">
            <input 
              type="text" 
              [(ngModel)]="task.taskName"
              placeholder="Task Name"
              class="form-input task-input">
            
            <div class="custom-status-dropdown task-input">
              <div class="status-dropdown-header" (click)="toggleStatusDropdown(goalIndex, taskIndex)">
                <span *ngIf="!task.taskStatus" class="status-placeholder">Select Task Status</span>
                <span *ngIf="task.taskStatus" class="status-selected-pill"
                  [ngClass]="{
                    'status-not-started-pill': task.taskStatus === 'Not Started',
                    'status-ongoing-pill': task.taskStatus === 'Ongoing',
                    'status-completed-pill': task.taskStatus === 'Completed',
                    'status-on-hold-pill': task.taskStatus === 'On Hold',
                    'status-cancelled-pill': task.taskStatus === 'Cancelled'
                  }">
                  {{task.taskStatus}}
                </span>
                <span class="dropdown-arrow">▼</span>
              </div>
              <div class="status-dropdown-options" *ngIf="isStatusDropdownOpen(goalIndex, taskIndex)">
                <div 
                  *ngFor="let status of taskStatusOptions"
                  class="status-option-pill"
                  [ngClass]="{
                    'status-not-started-pill': status === 'Not Started',
                    'status-ongoing-pill': status === 'Ongoing',
                    'status-completed-pill': status === 'Completed',
                    'status-on-hold-pill': status === 'On Hold',
                    'status-cancelled-pill': status === 'Cancelled'
                  }"
                  (click)="selectTaskStatus(goalIndex, taskIndex, status)">
                  {{status}}
                </div>
              </div>
            </div>
            
            <input 
              type="text" 
              [(ngModel)]="task.taskOwner"
              placeholder="Task Owner"
              class="form-input task-input">
            
            <!-- Show only Start Date for Ongoing status -->
            <input 
              *ngIf="task.taskStatus === 'Ongoing'"
              type="date" 
              [(ngModel)]="task.taskStartDate"
              title="Start Date"
              [attr.data-placeholder]="!task.taskStartDate ? 'Start Date' : null"
              class="form-date task-input task-date-input">
            
            <!-- Show Date Range for other statuses -->
            <div *ngIf="task.taskStatus && task.taskStatus !== 'Ongoing'" class="date-range-wrapper">
              <div class="date-range-container">
                <input 
                  type="date" 
                  [(ngModel)]="task.taskStartDate"
                  (change)="validateTaskEndDate(goalIndex, taskIndex)"
                  title="Start Date"
                  [attr.data-placeholder]="!task.taskStartDate ? 'Start Date' : null"
                  class="form-date task-input task-date-input">
                <span class="date-separator">to</span>
                <input 
                  type="date" 
                  [(ngModel)]="task.taskEndDate"
                  (change)="validateTaskEndDate(goalIndex, taskIndex)"
                  [min]="task.taskStartDate"
                  title="End Date"
                  [attr.data-placeholder]="!task.taskEndDate ? 'End Date' : null"
                  class="form-date task-input task-date-input"
                  [class.error-field]="hasTaskDateError(goalIndex, taskIndex)">
              </div>
              <span *ngIf="hasTaskDateError(goalIndex, taskIndex)" class="error-message task-error-message">{{ getTaskDateError(goalIndex, taskIndex) }}</span>
            </div>
            
            <!-- Empty placeholder when no status selected -->
            <div *ngIf="!task.taskStatus" class="date-placeholder task-input">
              Select status to show dates
            </div>
            
            <div class="task-actions">
              <button 
                class="delete-task-btn" 
                (click)="deleteTask(goalIndex, taskIndex)"
                *ngIf="goal.tasks.length > 1">
                <span class="btn-icon">🗑️</span>
                Delete
              </button>
            </div>
          </div>
        </div>

        <div class="task-buttons">
          <button class="add-task-btn" (click)="addTask(goalIndex)">
            <span class="btn-icon">📝</span>
            Add Task
          </button>
        </div>
      </div>

      <!-- Goal Action Buttons - Bottom row -->
      <div class="goal-actions-container" *ngIf="goalIndex === progressNotesForm.goals.length - 1">
        <!-- Remove Goal Button - Only show for goals after first -->
        <button class="delete-goal-btn" *ngIf="goalIndex > 0" (click)="deleteGoal(goalIndex)">
          <span class="btn-icon">🗑️</span>
          Remove Goal
        </button>
        
        <!-- Add Goal Button -->
        <button class="add-goal-btn" (click)="addGoal()">
          <span class="btn-icon">📝</span>
          Add Goal
        </button>
      </div>
    </div>
  </div>

  <!-- Form Actions -->
  <div class="form-actions">
    <button class="cancel-btn" (click)="cancelAddNotes()">Cancel</button>
    <button class="move-to-review-btn" (click)="moveToReview()" [disabled]="hasAnyValidationErrors()">Move to Review</button>
  </div>
</div>

<!-- Progress Review Form -->
<div *ngIf="showProgressReviewForm" class="progress-review-container">
  <!-- Header -->
  <div class="review-header">
    <h2>Progress Review</h2>
    <div class="review-actions" *ngIf="!isViewingFromCompletedTab">
      <button class="complete-btn" (click)="markProgressNoteComplete()">Mark Completed</button>
      <button class="edit-btn" (click)="enableEditMode()">Edit</button>
      <button class="save-btn" (click)="saveProgressReview()">Save changes</button>
    </div>
    <div class="review-actions" *ngIf="isViewingFromCompletedTab">
      <button class="cancel-btn" (click)="cancelProgressReview()">Close</button>
      <button class="incomplete-btn" (click)="markProgressNoteIncomplete()">Mark Incomplete</button>
    </div>
  </div>

  <!-- Top Section: Current Health Issues -->
  <div class="review-section">
    <div class="review-row-3">
      <div class="review-field">
        <label>Current Health Issues</label>
        <input 
          type="text" 
          [(ngModel)]="progressReviewForm.currentHealthIssues"
          disabled
          class="review-input">
      </div>
      <div class="review-field">
        <label>Medical Conditions</label>
        <input 
          type="text" 
          [(ngModel)]="progressReviewForm.medicalConditions"
          disabled
          class="review-input">
      </div>
      <div class="review-field">
        <label>Identified On</label>
        <input 
          type="date" 
          [(ngModel)]="progressReviewForm.identifiedOn"
          disabled
          class="review-input">
      </div>
    </div>
  </div>

  <!-- Goals Section -->
  <div class="review-section" *ngFor="let goal of progressReviewForm.goals; let goalIndex = index">
    <h3 class="section-title">Goal {{goalIndex + 1}}</h3>
    
    <!-- Goal Fields - All in One Row -->
    <div class="review-row-4">
      <div class="review-field">
        <label>Goals to be achieved</label>
        <input 
          type="text" 
          [(ngModel)]="goal.goalsToBeAchieved"
          disabled
          class="review-input">
      </div>
      <div class="review-field">
        <label>Goal Category</label>
        <input 
          type="text" 
          [(ngModel)]="goal.goalCategory"
          disabled
          class="review-input">
      </div>
      <div class="review-field">
        <label>Goal Start Date / Target Date</label>
        <input 
          type="text" 
          [value]="goal.goalStartDate + ' / ' + goal.goalEndDate"
          disabled
          class="review-input">
      </div>
      <div class="review-field">
        <label>Goal Priority Level</label>
        <div class="priority-pill-container">
          <button 
            *ngIf="goal.goalPriorityLevel === 'High'"
            class="priority-pill high-priority-pill selected"
            disabled>
            High Priority
          </button>
          <button 
            *ngIf="goal.goalPriorityLevel === 'Medium'"
            class="priority-pill medium-priority-pill selected"
            disabled>
            Medium Priority
          </button>
          <button 
            *ngIf="goal.goalPriorityLevel === 'Low'"
            class="priority-pill low-priority-pill selected"
            disabled>
            Low Priority
          </button>
        </div>
      </div>
    </div>

    <!-- Tasks Section -->
    <div class="tasks-review-section">
      <h4 class="subsection-title">Tasks</h4>
      <div class="task-review-row" *ngFor="let task of goal.tasks; let taskIndex = index">
        <div class="review-field">
          <label>Task</label>
          <input 
            type="text" 
            [(ngModel)]="task.task"
            disabled
            class="review-input">
        </div>
        <div class="review-field">
          <label>Task Status</label>
          <div class="review-status-field-container">
            <div class="task-status-pill-display"
              [ngClass]="{
                'status-not-started-pill': task.taskStatus === 'Not Started',
                'status-ongoing-pill': task.taskStatus === 'Ongoing',
                'status-completed-pill': task.taskStatus === 'Completed',
                'status-on-hold-pill': task.taskStatus === 'On Hold',
                'status-cancelled-pill': task.taskStatus === 'Cancelled'
              }">
              {{task.taskStatus || 'Not Set'}}
            </div>
          </div>
        </div>
        <div class="review-field">
          <label>Task Owner</label>
          <input 
            type="text" 
            [(ngModel)]="task.taskOwner"
            disabled
            class="review-input">
        </div>
        <!-- For Ongoing status - Show only Start Date -->
        <div class="review-field" *ngIf="task.taskStatus === 'Ongoing'">
          <label>Start Date</label>
          <input 
            type="date" 
            [(ngModel)]="task.taskStartDate"
            title="Start Date"
            [attr.data-placeholder]="!task.taskStartDate ? 'Start Date' : null"
            disabled
            class="review-input review-date-input">
        </div>
        
        <!-- For other statuses - Show Start Date and End Date separately with individual labels -->
        <ng-container *ngIf="task.taskStatus && task.taskStatus !== 'Ongoing'">
          <div class="review-field">
            <label>Start Date</label>
            <input 
              type="date" 
              [(ngModel)]="task.taskStartDate"
              title="Start Date"
              [attr.data-placeholder]="!task.taskStartDate ? 'Start Date' : null"
              disabled
              class="review-input review-date-input">
          </div>
          <div class="review-field">
            <label>End Date</label>
            <input 
              type="date" 
              [(ngModel)]="task.taskEndDate"
              title="End Date"
              [attr.data-placeholder]="!task.taskEndDate ? 'End Date' : null"
              disabled
              class="review-input review-date-input">
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Progress Summary Section -->
  <div class="review-section">
    <h3 class="section-title">Progress Summary</h3>
    <div class="review-row-1">
      <div class="review-field">
        <textarea 
          [(ngModel)]="progressReviewForm.progressSummary"
          placeholder="Type here"
          class="review-textarea"
          [disabled]="isViewingFromCompletedTab"
          rows="6"></textarea>
      </div>
    </div>
  </div>

  <!-- Bottom Actions -->
  <div class="review-footer" *ngIf="!isViewingFromCompletedTab">
    <button class="cancel-btn" (click)="cancelProgressReview()">Close</button>
    <button class="save-btn" (click)="saveProgressReview()">Save changes</button>
  </div>
  <div class="review-footer" *ngIf="isViewingFromCompletedTab">
    <button class="cancel-btn" (click)="cancelProgressReview()">Close</button>
  </div>
</div>

    <!-- Priority List Content -->
<div *ngIf="activeProgressTab === 'priority'">
  <!-- Add New Notes Button -->
  <div class="add-notes-container" *ngIf="!showAddNotesForm && !showProgressReviewForm">
    <button class="add-notes-btn" (click)="addNewNotes()">Add New Notes</button>
  </div>
  
  <!-- Table Content -->
  <div *ngIf="!showAddNotesForm && !showProgressReviewForm" class="table-wrapper priority-table">
    <table mat-table [dataSource]="dataSource">
    
    <!-- Health Issues Column -->
    <ng-container matColumnDef="HealthIssues">
      <th mat-header-cell *matHeaderCellDef> Health Issues </th>
      <td mat-cell *matCellDef="let element">
        <div class="health-issue-dropdown-container">
          <span class="health-issue-text">{{element.healthIssues}}</span>
          
          <!-- Debug: Show button condition -->
          <!-- Goals: {{element.rawData?.goals?.length || 0}} -->
          
          <button 
            class="health-issue-dropdown-btn" 
            [class.dropdown-open]="isHealthIssueDropdownOpen(element.id)"
            (click)="toggleHealthIssueDropdown(element.id, $event)"
            *ngIf="element.rawData && element.rawData.goals && element.rawData.goals.length > 0"
            title="View Goals & Tasks">
            <span class="dropdown-icon" [class.icon-rotated]="isHealthIssueDropdownOpen(element.id)">▼</span>
          </button>
          
          <!-- Dropdown Card - Debug info -->
          <!-- Is Open: {{isHealthIssueDropdownOpen(element.id)}} -->
          
          <div class="health-issue-dropdown-card" *ngIf="isHealthIssueDropdownOpen(element.id)" style="background: white !important;">
            <div class="dropdown-card-header">
              <h4>Goals & Tasks for {{element.healthIssues}}</h4>
            </div>
            <div class="dropdown-card-content">
              <div class="goal-item" *ngFor="let goal of element.rawData.goals; let goalIdx = index">
                <div class="goal-header">
                  <strong>Goal {{goalIdx + 1}}:</strong> {{goal.goalToBeAchieved}}
                </div>
                <div class="task-list" *ngIf="goal.tasks && goal.tasks.length > 0">
                  <div class="task-item-dropdown" *ngFor="let task of goal.tasks">
                    <div class="task-row">
                      <div class="task-info">
                        <span class="task-label">Task:</span>
                        <span class="task-value">{{task.taskName || '-'}}</span>
                      </div>
                      <div class="task-info">
                        <span class="task-label">Status:</span>
                        <span class="task-status-badge"
                          [ngClass]="{
                            'status-not-started': task.taskStatus === 'Not Started',
                            'status-ongoing': task.taskStatus === 'Ongoing',
                            'status-completed': task.taskStatus === 'Completed',
                            'status-on-hold': task.taskStatus === 'On Hold',
                            'status-cancelled': task.taskStatus === 'Cancelled'
                          }">
                          {{task.taskStatus || '-'}}
                        </span>
                      </div>
                    </div>
                    <div class="task-row">
                      <div class="task-info">
                        <span class="task-label">Start Date:</span>
                        <span class="task-value">
                          {{task.taskStartDate && !task.taskStartDate.startsWith('0001-01-01') ? (task.taskStartDate | date: 'MMMM d, y') : '----'}}
                        </span>
                      </div>
                      <div class="task-info">
                        <span class="task-label">End Date:</span>
                        <span class="task-value">
                          {{task.taskEndDate && !task.taskEndDate.startsWith('0001-01-01') ? (task.taskEndDate | date: 'MMMM d, y') : '----'}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="no-tasks" *ngIf="!goal.tasks || goal.tasks.length === 0">
                  No tasks available for this goal
                </div>
              </div>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    
    <!-- Identified On Column -->
    <ng-container matColumnDef="IdentifiedOn">
      <th mat-header-cell *matHeaderCellDef> Identified On </th>
      <td mat-cell *matCellDef="let element">{{element.identifiedOn | date: 'MMMM d, y'}} </td>
    </ng-container>
    
    <!-- Assigned To Column -->
    <ng-container matColumnDef="AssignedTo">
      <th mat-header-cell *matHeaderCellDef> Assigned To </th>
      <td mat-cell *matCellDef="let element">{{element.assignedTo}} </td>
    </ng-container>
    
    <!-- Priority Column -->
    <ng-container matColumnDef="Priority">
      <th mat-header-cell *matHeaderCellDef> Priority </th>
      <td mat-cell *matCellDef="let element">{{element.priority}} </td>
    </ng-container>
    
    <!-- Actions Column -->
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
        <button class="action-btn archive-btn" (click)="moveToArchive(element)">Move to Archive</button>
        <button class="action-btn view-btn" (click)="viewDetail(element)">View Detail</button>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  
    <div style="display:flex;">
      <mat-paginator #paginator
                     (page)="pageChangeEvent($event)"
                     [length]="totalRecords"
                     [pageSize]="pageSize"
                     [pageIndex]="0"
                     showFirstLastButton>
      </mat-paginator>
    </div>
      </div>
    </div>

<!-- Archived List Content -->
<div *ngIf="activeProgressTab === 'archived'">
  <!-- Add New Notes Button -->
  <div class="add-notes-container" *ngIf="!showAddNotesForm && !showProgressReviewForm">
    <button class="add-notes-btn" (click)="addNewNotes()">Add New Notes</button>
  </div>
  
  <!-- Table Content -->
  <div *ngIf="!showAddNotesForm && !showProgressReviewForm" class="table-wrapper archived-table">
    <table mat-table [dataSource]="archivedDataSource">
    
    <!-- Health Issues Column -->
    <ng-container matColumnDef="HealthIssues">
      <th mat-header-cell *matHeaderCellDef> Health Issues </th>
      <td mat-cell *matCellDef="let element">
        <div class="health-issue-dropdown-container">
          <span class="health-issue-text">{{element.healthIssues}}</span>
          
          <!-- Debug: Show button condition -->
          <!-- Goals: {{element.rawData?.goals?.length || 0}} -->
          
          <button 
            class="health-issue-dropdown-btn" 
            [class.dropdown-open]="isHealthIssueDropdownOpen(element.id)"
            (click)="toggleHealthIssueDropdown(element.id, $event)"
            *ngIf="element.rawData && element.rawData.goals && element.rawData.goals.length > 0"
            title="View Goals & Tasks">
            <span class="dropdown-icon" [class.icon-rotated]="isHealthIssueDropdownOpen(element.id)">▼</span>
          </button>
          
          <!-- Dropdown Card - Debug info -->
          <!-- Is Open: {{isHealthIssueDropdownOpen(element.id)}} -->
          
          <div class="health-issue-dropdown-card" *ngIf="isHealthIssueDropdownOpen(element.id)" style="background: white !important;">
            <div class="dropdown-card-header">
              <h4>Goals & Tasks for {{element.healthIssues}}</h4>
            </div>
            <div class="dropdown-card-content">
              <div class="goal-item" *ngFor="let goal of element.rawData.goals; let goalIdx = index">
                <div class="goal-header">
                  <strong>Goal {{goalIdx + 1}}:</strong> {{goal.goalToBeAchieved}}
                </div>
                <div class="task-list" *ngIf="goal.tasks && goal.tasks.length > 0">
                  <div class="task-item-dropdown" *ngFor="let task of goal.tasks">
                    <div class="task-row">
                      <div class="task-info">
                        <span class="task-label">Task:</span>
                        <span class="task-value">{{task.taskName || '-'}}</span>
                      </div>
                      <div class="task-info">
                        <span class="task-label">Status:</span>
                        <span class="task-status-badge"
                          [ngClass]="{
                            'status-not-started': task.taskStatus === 'Not Started',
                            'status-ongoing': task.taskStatus === 'Ongoing',
                            'status-completed': task.taskStatus === 'Completed',
                            'status-on-hold': task.taskStatus === 'On Hold',
                            'status-cancelled': task.taskStatus === 'Cancelled'
                          }">
                          {{task.taskStatus || '-'}}
                        </span>
                      </div>
                    </div>
                    <div class="task-row">
                      <div class="task-info">
                        <span class="task-label">Start Date:</span>
                        <span class="task-value">
                          {{task.taskStartDate && !task.taskStartDate.startsWith('0001-01-01') ? (task.taskStartDate | date: 'MMMM d, y') : '----'}}
                        </span>
                      </div>
                      <div class="task-info">
                        <span class="task-label">End Date:</span>
                        <span class="task-value">
                          {{task.taskEndDate && !task.taskEndDate.startsWith('0001-01-01') ? (task.taskEndDate | date: 'MMMM d, y') : '----'}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="no-tasks" *ngIf="!goal.tasks || goal.tasks.length === 0">
                  No tasks available for this goal
                </div>
              </div>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    
    <!-- Identified On Column -->
    <ng-container matColumnDef="IdentifiedOn">
      <th mat-header-cell *matHeaderCellDef> Identified On </th>
      <td mat-cell *matCellDef="let element">{{element.identifiedOn | date: 'MMMM d, y'}} </td>
    </ng-container>
    
    <!-- Assigned To Column -->
    <ng-container matColumnDef="AssignedTo">
      <th mat-header-cell *matHeaderCellDef> Assigned To </th>
      <td mat-cell *matCellDef="let element">{{element.assignedTo}} </td>
    </ng-container>
    
    <!-- Priority Column -->
    <ng-container matColumnDef="Priority">
      <th mat-header-cell *matHeaderCellDef> Priority </th>
      <td mat-cell *matCellDef="let element">{{element.priority}} </td>
    </ng-container>
    
    <!-- Actions Column -->
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
        <button class="action-btn restore-btn" (click)="restoreFromArchive(element)">Restore</button>
        <button class="action-btn view-btn" (click)="viewDetail(element)">View Detail</button>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  
    <div style="display:flex;">
      <mat-paginator #archivedPaginator
                     (page)="archivedPageChangeEvent($event)"
                     [length]="archivedTotalRecords"
                     [pageSize]="pageSize"
                     [pageIndex]="0"
                     showFirstLastButton>
      </mat-paginator>
    </div>
  </div>
</div>

<!-- Completed Progress Notes Content -->
<div *ngIf="activeProgressTab === 'completed'">
  <!-- Table Content -->
  <div *ngIf="!showAddNotesForm && !showProgressReviewForm" class="table-wrapper completed-table">
    <table mat-table [dataSource]="completedDataSource">
    
    <!-- Health Issues Column -->
    <ng-container matColumnDef="HealthIssues">
      <th mat-header-cell *matHeaderCellDef> Health Issues </th>
      <td mat-cell *matCellDef="let element">
        <div class="health-issue-dropdown-container">
          <span class="health-issue-text">{{element.healthIssues}}</span>
          
          <button 
            class="health-issue-dropdown-btn" 
            [class.dropdown-open]="isHealthIssueDropdownOpen(element.id)"
            (click)="toggleHealthIssueDropdown(element.id, $event)"
            *ngIf="element.rawData && element.rawData.goals && element.rawData.goals.length > 0"
            title="View Goals & Tasks">
            <span class="dropdown-icon" [class.icon-rotated]="isHealthIssueDropdownOpen(element.id)">▼</span>
          </button>
          
          <div class="health-issue-dropdown-card" *ngIf="isHealthIssueDropdownOpen(element.id)" style="background: white !important;">
            <div class="dropdown-card-header">
              <h4>Goals & Tasks for {{element.healthIssues}}</h4>
            </div>
            <div class="dropdown-card-content">
              <div class="goal-item" *ngFor="let goal of element.rawData.goals; let goalIdx = index">
                <div class="goal-header">
                  <strong>Goal {{goalIdx + 1}}:</strong> {{goal.goalToBeAchieved}}
                </div>
                <div class="task-list" *ngIf="goal.tasks && goal.tasks.length > 0">
                  <div class="task-item-dropdown" *ngFor="let task of goal.tasks">
                    <div class="task-row">
                      <div class="task-info">
                        <span class="task-label">Task:</span>
                        <span class="task-value">{{task.taskName || '-'}}</span>
                      </div>
                      <div class="task-info">
                        <span class="task-label">Status:</span>
                        <span class="task-status-badge"
                          [ngClass]="{
                            'status-not-started': task.taskStatus === 'Not Started',
                            'status-ongoing': task.taskStatus === 'Ongoing',
                            'status-completed': task.taskStatus === 'Completed',
                            'status-on-hold': task.taskStatus === 'On Hold',
                            'status-cancelled': task.taskStatus === 'Cancelled'
                          }">
                          {{task.taskStatus || '-'}}
                        </span>
                      </div>
                    </div>
                    <div class="task-row">
                      <div class="task-info">
                        <span class="task-label">Start Date:</span>
                        <span class="task-value">
                          {{task.taskStartDate && !task.taskStartDate.startsWith('0001-01-01') ? (task.taskStartDate | date: 'MMMM d, y') : '----'}}
                        </span>
                      </div>
                      <div class="task-info">
                        <span class="task-label">End Date:</span>
                        <span class="task-value">
                          {{task.taskEndDate && !task.taskEndDate.startsWith('0001-01-01') ? (task.taskEndDate | date: 'MMMM d, y') : '----'}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="no-tasks" *ngIf="!goal.tasks || goal.tasks.length === 0">
                  No tasks available for this goal
                </div>
              </div>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    
    <!-- Identified On Column -->
    <ng-container matColumnDef="IdentifiedOn">
      <th mat-header-cell *matHeaderCellDef> Identified On </th>
      <td mat-cell *matCellDef="let element">{{element.identifiedOn | date: 'MMMM d, y'}} </td>
    </ng-container>
    
    <!-- Assigned To Column -->
    <ng-container matColumnDef="AssignedTo">
      <th mat-header-cell *matHeaderCellDef> Assigned To </th>
      <td mat-cell *matCellDef="let element">{{element.assignedTo}} </td>
    </ng-container>
    
    <!-- Priority Column -->
    <ng-container matColumnDef="Priority">
      <th mat-header-cell *matHeaderCellDef> Priority </th>
      <td mat-cell *matCellDef="let element">{{element.priority}} </td>
    </ng-container>
    
    <!-- Actions Column - Only View Detail button -->
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
        <button class="action-btn view-btn" (click)="viewDetail(element, true)">View Detail</button>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="completedDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: completedDisplayedColumns;"></tr>
  </table>
  
    <div style="display:flex;">
      <mat-paginator #completedPaginator
                     (page)="completedPageChangeEvent($event)"
                     [length]="completedTotalRecords"
                     [pageSize]="pageSize"
                     [pageIndex]="0"
                     showFirstLastButton>
      </mat-paginator>
    </div>
  </div>
</div>

<!-- Old Progress Notes Content -->
<div *ngIf="activeProgressTab === 'oldProgressNotes'">
  <!-- Table Content -->
  <div *ngIf="!showAddNotesForm && !showProgressReviewForm" class="table-wrapper">
    <table mat-table [dataSource]="oldProgressNotesDataSource">
    
    <!-- Date Column -->
    <ng-container matColumnDef="Date">
      <th mat-header-cell *matHeaderCellDef> Date </th>
      <td mat-cell *matCellDef="let element">{{element.date}} </td>
    </ng-container>
    
    <!-- Summary Column -->
    <ng-container matColumnDef="Summary">
      <th mat-header-cell *matHeaderCellDef> Summary </th>
      <td mat-cell *matCellDef="let element">{{element.summary}} </td>
    </ng-container>
    
    <!-- Outcome Column -->
    <ng-container matColumnDef="Outcome">
      <th mat-header-cell *matHeaderCellDef> Outcome </th>
      <td mat-cell *matCellDef="let element">{{element.outcome}} </td>
    </ng-container>
    
    <!-- Action Plan Column -->
    <ng-container matColumnDef="ActionPlan">
      <th mat-header-cell *matHeaderCellDef> Action Plan </th>
      <td mat-cell *matCellDef="let element">{{element.actionPlan}} </td>
    </ng-container>
    
    <!-- Added By Column -->
    <ng-container matColumnDef="AddedBy">
      <th mat-header-cell *matHeaderCellDef> Added By </th>
      <td mat-cell *matCellDef="let element">{{element.addedBy}} </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="oldProgressNotesColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: oldProgressNotesColumns;"></tr>
  </table>
  
    <div style="display:flex;">
      <mat-paginator #oldProgressNotesPaginator
                     (page)="oldProgressNotesPageChangeEvent($event)"
                     [length]="oldProgressNotesTotalRecords"
                     [pageSize]="pageSize"
                     [pageIndex]="0"
                     showFirstLastButton>
      </mat-paginator>
    </div>
  </div>
</div>

<!-- Validation Modal -->
<div *ngIf="showValidationModal" class="validation-modal-overlay">
  <div class="validation-modal-card">
    <!-- Warning Icon -->
    <div class="warning-icon">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    
    <!-- Validation Title -->
    <h2 class="validation-title">Required Fields Missing</h2>
    
    <!-- Validation Message -->
    <p class="validation-message">{{ validationMessage }}</p>
    
    <!-- OK Button -->
    <button class="validation-ok-btn" (click)="closeValidationModal()">OK</button>
  </div>
</div>

<!-- Success Modal -->
<div *ngIf="showSuccessModal" class="success-modal-overlay">
  <div class="success-modal-card">
    <!-- Success Icon -->
    <div class="success-icon">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    
    <!-- Success Title -->
    <h2 class="success-title">Progress Notes Saved Successfully!</h2>
    
    <!-- Success Message -->
    <p class="success-message">
      Your updates have been saved and the member's progress notes have been refreshed in the priority list. 
      You can continue managing action items or review the complete history as needed.
    </p>
    
    <!-- Continue Button -->
    <button class="continue-btn" (click)="continueFromSuccess()">Continue</button>
  </div>
</div>